import React from "react";
import "./Blog_card.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { IDS } from "../../../utils/IDS";

function Blog_card({ baseLink, blogData }) {
  return (
    <>
      <Link to={baseLink}>
        <section className="Blog_card">
          <div className="main_content_holder">
            <div className="img_holder">
              <img
                className="Blog_img"
                // src={process.env.REACT_APP_IMG_URL + blogData.image}
                src={IDS?.IMG_URL + blogData.image}
                alt={"Blog_img"}
              />
            </div>
            <div className="text_holder">
              <p className="title_text heading_text">
                {blogData.BlogLanguage?.name}
              </p>
              <p className="descn para_text">
                {blogData.BlogLanguage?.description}
              </p>
            </div>
          </div>

          {/* old code */}
          {/* <>
            <div className="img_holder">
              <img
                className="Blog_img"
                src={process.env.REACT_APP_IMG_URL + blogData.image}
                alt={"Blog_img"}
              />

              <FontAwesomeIcon className="arrow_icon" icon={faArrowRight} />
            </div>
            <div className="text_holder">
              <h4>{blogData.name}</h4>
              <p>{blogData.subname}</p>
            </div>
          </> */}
        </section>
      </Link>
    </>
  );
}

export default Blog_card;
